import React from "react"

import { RichText as Wrapper } from "../../RichText/RichText"
import { withRichText } from "./withRichText"
import { SectionWrapper, RichTextWrapper } from "./RichTextStyles"

export const RichText = withRichText(({ content, secondaryEnabled, secondaryContent, background }) => {

  
  return (
    <SectionWrapper background={background}>
      {secondaryEnabled ? (
        <RichTextWrapper>
          <Wrapper>{content}</Wrapper>
          <Wrapper>{secondaryContent}</Wrapper>
        </RichTextWrapper>
      ) : (<Wrapper>{content}</Wrapper>)}
    </SectionWrapper>
  )
})

export default RichText
